<div class="h-100 w-100 d-flex flex-grow-1 flex-column justify-content-center">
	<div class="d-flex flex-column align-items-center justify-content-center py-4">
		<img
			width="114"
			height="114"
			src="/assets/images/not-found.svg"
			(load)="onImageLoaded()"
			class="mb-4"
			alt="Not found"
		/>
		<div [hidden]="!isShowContent" class="title">Error</div>
		<div [hidden]="!isShowContent" class="mt-2 subtitle text-gray-text-color">Oops something went wrong</div>
	</div>
</div>
